import { render, staticRenderFns } from "./ConversationHeader.vue?vue&type=template&id=2e9bbec3&scoped=true&"
import script from "./ConversationHeader.vue?vue&type=script&lang=js&"
export * from "./ConversationHeader.vue?vue&type=script&lang=js&"
import style0 from "./ConversationHeader.vue?vue&type=style&index=0&id=2e9bbec3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9bbec3",
  null
  
)

export default component.exports